/**
 * Full-page / large background images for signed-out and regular signed-in flows.
 * Admin-only assets (e.g. submissions list) are intentionally omitted.
 */
const R2_BASE = "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev";

/** Dark / scrim hero frame (loops into `background.png` in App). */
export const HOME_PRE_BACKGROUND_URL = `${R2_BASE}/images/home/pre-background.png`;

/** Bright hero frame — same artwork composition as pre, aligned in design. */
export const HOME_MAIN_BACKGROUND_URL = `${R2_BASE}/images/home/background.png`;

/** Portrait / phone hero frames (narrow viewports — see `HOME_HERO_PORTRAIT_MEDIA`). */
export const HOME_PRE_BACKGROUND_PHONE_URL = `${R2_BASE}/images/home/pre%20background%20phone.png`;
export const HOME_MAIN_BACKGROUND_PHONE_URL = `${R2_BASE}/images/home/background%20phone%202.png`;

/** Mobile nav drawer panel (Header). Preloaded via bootstrap alongside other marketing art. */
export const HOME_DRAWER_SIDEBAR_URL = `${R2_BASE}/images/home/sidebar.png`;

export const WIZARD_LANGUAGE_PAGE_BACKGROUND_URL = `${R2_BASE}/images/wizard/1_background.png`;

export const REGULAR_USER_BACKGROUND_IMAGE_URLS: readonly string[] = [
  HOME_PRE_BACKGROUND_URL,
  HOME_MAIN_BACKGROUND_URL,
  HOME_PRE_BACKGROUND_PHONE_URL,
  HOME_MAIN_BACKGROUND_PHONE_URL,
  HOME_DRAWER_SIDEBAR_URL,
  `${R2_BASE}/images/home/sign-in.png`,
  `${R2_BASE}/images/home/sign-up.png`,
  WIZARD_LANGUAGE_PAGE_BACKGROUND_URL,
  `${R2_BASE}/images/wizard/1b_background.png`,
  `${R2_BASE}/images/wizard/2_background.png`,
  `${R2_BASE}/images/wizard/3_background.png`,
  `${R2_BASE}/images/wizard/submitted.png?v=3`,
  `${R2_BASE}/icons/background.png`,
];
